import React from 'react';

const Notification = ({ noticeMessage, noticeClass = 'success' }) => {
  return (
    <div
      data-notice-dismissible="false"
      className={`notice notice--${noticeClass} notice--row`}
    >
      <p className="notice__message">{noticeMessage}</p>
    </div>
  );
};

export default Notification;
